export async function getCompanyWebHistory({ signal } = {}) {
  const response = await fetch('/bff/company-web-history', { credentials: 'same-origin', signal });
  if (!response.ok) {
    const error = new Error('Company web history unavailable');
    error.status = response.status;
    throw error;
  }
  return response.json();
}
